import Vue from 'vue';
import App from './App.vue';
import router from './router';

import vuetify from '@/plugins/vuetify';
import store from './store';
import i18n from './i18n';
import { sync } from 'vuex-router-sync';

sync(store, router);
new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
